export default {
  depthHistory: [],
  token: '',
  userName: '',
  bindTicket: '',
  bookingContactInfo: null,
  goodsCartNum: 0,
  smCartNum: 0,
  indexPopupMessageLoaded: false,
  bookingPage: '',
  isMiniApp: false,
  isMaskValue: true,
  showCartCancelOrder: false
}
